<script lang="ts">
    import cn from "classnames";

    export let isFeatured = false;
</script>

<div
    class={cn("gw-crv-item", {
        "gw-crv-item-featured": isFeatured,
    })}
>
    <slot name="media" />

    <div
        class={cn("gw-crv-item__wrapper", {
            "gw-crv-item__wrapper-featured": isFeatured,
        })}
    >
        <slot name="rating" />
        <slot name="title" />
        <slot name="text" />
    </div>

    <div class="gw-crv-item__divider" />

    <div
        class={cn("gw-crv-item-product", {
            "gw-crv-item-product-featured": isFeatured,
        })}
    >
        <div class="gw-crv-item-product__image-wrapper">
            <slot name="product-image" />
        </div>
        <div class="gw-crv-item-product__info">
            <slot name="product-tags" />
            <slot name="product-title" />
            <slot name="product-price" />
        </div>
        <slot name="product-wishlist-btn" />
    </div>
</div>

<style lang="postcss">
    :global(.gw-btn.gw-btn-with-icon:hover) {
        background-color: transparent;
    }

    .gw-crv-item {
        --gw-rv-icon-starColor: #ff7a6c;

        background-color: #fff;
        overflow: hidden;
        height: 100%;
        display: flex;
        flex-direction: column;

        &-featured {
            border-radius: 10px;
            margin-right: 16px;
            margin-left: 16px;
        }

        &__wrapper {
            flex: 1;
            padding: 28px 0 24px;
            &-featured {
                padding: 28px 24px 24px;
            }
        }

        &__divider {
            border-bottom: 1px dashed #d4d4d4;
        }

        &-product {
            display: flex;
            align-items: center;
            gap: 14px;
            padding: 24px 0 0;
            &-featured {
                padding: 24px 24px 24px 20px;
            }

            &__image-wrapper {
                width: 80px;
                height: 80px;
                border-radius: 50%;
            }

            &__info {
                width: calc(100% - 80px - 32px - 24px);
                flex: 1;
            }
        }
    }
    @media all and (max-width: 600px) {
        .gw-crv-item {
            &__wrapper {
                padding: 12px 0 16px;
                &-featured {
                    padding: 20px 20px 16px;
                }
            }
            &-product {
                padding: 14px 0 0;
                gap: 8px;
                align-items: flex-start;

                &:not(&-featured) {
                    :global(.gw-wl-wishlist-icon) {
                        width: 18px;
                        height: 18px;
                    }
                }
                &-featured {
                    padding: 20px;
                }
                &__image-wrapper {
                    width: 42px;
                    height: 42px;
                }
            }
        }
    }
</style>
